import { Component, Input, inject } from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { Dipendente } from 'src/app/models/dipendente';
import { Articoli } from 'src/app/models/articoli';
import { MovimentoArticolo } from 'src/app/models/movimento-articolo';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-dafirmare-grid-view',
  templateUrl: './dafirmare-grid-view.component.html',
  styleUrls: ['./dafirmare-grid-view.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoLookupComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxTemplateDirective,
  ],
  standalone: true,
})
export class DafirmareGridViewComponent {
  private movS = inject(MovimentoArticoliService);
  private dipS = inject(DipendentiService);
  private articoliS = inject(ArticoliService);
  private nS = inject(NavigatorService);

  @Input() listMovimenti: MovimentoArticolo[];

  firmati = false;
  dataSource: any;
  listDip: Dipendente[] = [];
  listArticoli: Articoli[] = [];
  listMovArticoli: MovimentoArticolo[] = [];

  constructor() {
    this.dipS.listTemp().subscribe((dati) => {
      this.listDip = dati;
    });
    this.articoliS.listTemp().subscribe((dati) => {
      this.listArticoli = dati.filter(x => x.attivo == true);
    });
    this.movS.listMovimentiArticoli.subscribe((dati) => {
      this.listMovArticoli = dati;
      this.loadDataSource();
    });
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.listMovArticoli
          ?.filter((m) => m.firmato == this.firmati)
          .sort((a, b) => (a.data < b.data ? 1 : -1));
      },
    });
  }
  /*
  get getDataSource():any{
    return new CustomStore({
      key: 'id',
      load: (loadOptions) => {
        return this.movS.listMovimentiDpi?.filter(m => m.firmato == this.firmati);
      }
    });
    
  }*/

  firmaDocumento(mov: MovimentoArticolo) {
    console.log('mov da firmare' + mov);
    this.nS.goToDocMovimento(mov.progr);
  }

  goToConsegna(e: any){
    this.nS.goToDocMovimento(e.data.progr);
  }
}
